const ColumnSparkline = ({
  data,
  width = 60,
  height = 30,
  color = '#0066cc',
  opacity = 0.8,
  baselineColor = '#cccccc',
  baselineWidth = 1,
  className = ''
}) => {
  const { bars, baselineY } = useMemo(() => {
    if (!data || data.length === 0) return { bars: [], baselineY: height - 2 };

    const min = Math.min(...data);
    const max = Math.max(...data);
    const range = max - min || 1;

    const padding = 2;
    const effectiveWidth = width - padding * 2;
    const effectiveHeight = height - padding * 2;
    const baselineY = height - padding;

    // Calculate bar width with no gaps - bars touch each other
    const barWidth = effectiveWidth / data.length;

    const bars = data.map((value, i) => {
      const x = (i * barWidth) + padding;
      const barHeight = ((value - min) / range) * effectiveHeight;
      const y = baselineY - barHeight;

      return { x, y, width: barWidth, height: barHeight };
    });

    return { bars, baselineY };
  }, [data, width, height]);

  if (!data || data.length === 0) {
    return <div className={className} style={{ width, height, display: 'inline-block' }} />;
  }

  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      style={{ display: 'inline-block', verticalAlign: 'middle' }}
    >
      {bars.map((bar, i) => (
        <rect
          key={i}
          x={bar.x}
          y={bar.y}
          width={bar.width}
          height={bar.height}
          fill={color}
          fillOpacity={opacity}
        />
      ))}

      {/* Baseline */}
      <line
        x1={2}
        y1={baselineY}
        x2={width - 2}
        y2={baselineY}
        stroke={baselineColor}
        strokeWidth={baselineWidth}
      />
    </svg>
  );
};

export default ColumnSparkline;
